import { render } from "./ImageViewerToolbar.vue?vue&type=template&id=56dcf053&scoped=true&ts=true"
import script from "./ImageViewerToolbar.vue?vue&type=script&lang=ts"
export * from "./ImageViewerToolbar.vue?vue&type=script&lang=ts"

import "./ImageViewerToolbar.vue?vue&type=style&index=0&id=56dcf053&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56dcf053"]])

export default __exports__